import { Button, Select } from '../../../atoms';
import type { CustomerStoriesCarouselProps } from '../types';

export const CategoriesButtonGroup = ({
  categories,
  onCategoryChange,
  selectedCategoryId,
}: Pick<CustomerStoriesCarouselProps, 'categories' | 'onCategoryChange' | 'selectedCategoryId'>) => {
  if (categories.length === 0) {
    return null;
  }

  const allBtn = (
    <Button variant={selectedCategoryId === null ? 'primary' : 'secondary'} onClick={() => onCategoryChange(null)}>
      All
    </Button>
  );

  return (
    <>
      <div className="payflow-ui-customer-stories-carousel__categories desktop-only">
        {allBtn}
        {categories.map((category) => (
          <Button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            variant={selectedCategoryId === category.id ? 'primary' : 'secondary'}
          >
            {category.name}
          </Button>
        ))}
      </div>

      <div className="payflow-ui-customer-stories-carousel__categories mobile-only">
        {allBtn}
        <Select
          variant={selectedCategoryId !== null ? 'button-like' : 'button-like-secondary'}
          value={selectedCategoryId ?? ''}
          onValueChange={(value) => {
            const newValue = value === '' ? null : value;

            onCategoryChange(newValue);
          }}
          placeholder={categories[0]?.name}
          options={categories.map((category) => ({
            label: category.name,
            value: category.id,
            disabled: selectedCategoryId === category.id,
          }))}
        />
      </div>
    </>
  );
};
